/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Loader from 'react-loader-spinner';
import {
  Typography,
  Tooltip,
  CircularProgress,
  Grid,
  List,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LinearProgressWithLabel from '../../../shared/LinearProgressWithLabel';
import UnitResultItemList from './UnitResultItemList';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  spacing: {
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  doubleSpacing: {
    flexBasis: '66.66%',
    flexShrink: 0,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontWeight: '500',
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const ResultsPanel = ({
  module,
}) => {
  const { name, _id, isRise } = module;
  const classes = useStyles();
  const [progress, setProgress] = useState(null);
  const [percentageQuiz, setPercentageQuiz] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const max = module.units.length;
    let success = 0;
    let percentage = 0;

    module.units.forEach((unit) => {
      if (unit.result?.success === true || unit.result?.completion === true) {
        success += 1;
      }

      if (
        unit.unit.isFinalQuiz
      && unit.result
      && unit.result.score
      && (unit.result.completion || unit.result.success)
      ) {
      // Cas incohérent LRS : scaled = 0 mais quiz réussi
        if (
          unit.result.score.scaled === 0
        && unit.result.completion === true
        && unit.result.success === true
        ) {
          percentage = 100;
        } else {
          percentage = (((unit.result?.score?.scaled || 0) / 1) * 100);
        }
      }
    });

    success = (success / max) * 100;

    setProgress(success);
    setPercentageQuiz(percentage.toFixed(1));
  }, []);

  const getScore = (() => {
    if (module && module.units && module.units.length > 0) {
      return module.units[0].result?.score
        ? (((module.units[0]?.result?.score?.raw || 0) / 100) * 100).toFixed(1)
        : (module.units[0].result.completion && module.units[0].result.success ? 100 : 0);
    }
    return 0;
  });
  const isLoading = module.units === null;
  return (
    <Accordion
      TransitionProps={{ unmountOnExit: true }}
      onChange={() => setOpen(!open)}
      expanded={open}
      aria-busy={isLoading}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${_id}-content`}
        id={`panel${_id}-header`}
      >
        <Typography className={`${classes.heading} ${classes.spacing}`}>{name}</Typography>
        {
          !isRise && (module._id !== '6022645fb63d9a00bd5e08fa' && module._id !== '6022645fb63d9a00bd5e08fb') && (
            <Typography
              component="div"
              className={`${classes.secondaryHeading} ${classes.spacing}`}
            >
              Quiz:
              <span aria-live="polite">
                {
                progress === null
                  ? (
                    <Grid>
                      <CircularProgress size={15} />
                    </Grid>
                  )
                  : ` ${percentageQuiz} %`
              }
              </span>
            </Typography>
          )
        }
        <Tooltip title="Progression de l'unité">
          <div className={`${classes.secondaryHeading} ${isRise ? classes.doubleSpacing : classes.spacing}`}>
            <Grid container direction="row">
              <Grid item md={4}>
                <Typography component="span" className={classes.secondaryHeading}>Progression: </Typography>
              </Grid>
              <Grid item md={8}>
                <LinearProgressWithLabel
                  value={progress === null ? 0 : (isRise ? Number(getScore()) : Number(progress))}
                />
              </Grid>
            </Grid>
          </div>
        </Tooltip>
      </AccordionSummary>
      <AccordionDetails>
        {module.units === null ? (
          <div role="status" aria-live="polite">
            <Loader
              type="Oval"
              color="#00BFFF"
              height={150}
              width={150}
              style={{ margin: 'auto' }}
            />
          </div>
        ) : (
          <List className={classes.root}>
            {module.units.map((unit, i) => (
              <UnitResultItemList
                key={unit.unit?._id || `${module._id}-unit-${i}`}
                module={module}
                unit={unit}
                index={i}
                quizPercent={progress === null ? 0 : (isRise ? getScore() : percentageQuiz)}
              />
            ))}
          </List>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

ResultsPanel.propTypes = {
  module: PropTypes.object.isRequired,
};

export default ResultsPanel;
